<mat-card class="mat-elevation-z8 container-card">
    <app-search-bar [filterFields]="['nome']" [filterMap]="{ nome: ['nome'] }" [filterLabels]="{ nome: ['nome'] }" (filtersChanged)="onFilterChanged($event)">
    </app-search-bar>

    <app-shared-table [dataSource]="dataSourceOneBox" [displayedColumns]="['name', 'triggerType', 'description', 'actions']" [columnLabels]="{ name: 'Nome', triggerType: 'Attivazione', description: 'Descrizione' }" [length]="totalItems" [pageSize]="pageSize"
        [pageIndex]="pageIndex" (pageChanged)="onPageChanged($event)" (sortChanged)="onSortChanged($event)" (openModal)="openDialog($event)" [isLoading]="isLoading" [hasError]="hasError">
    </app-shared-table>

    <app-loading [showLoading]="isLoadingFullScreen"></app-loading>
</mat-card>